module.exports = __webpack_public_path__ + "static/img/公交bg@2x.eb797f83.png";